import { reactive, Vue2 } from 'vue-demi';
import zhCN from './lang/zh-cn';
const responsiveFn = Vue2 ? Vue2.observable : reactive;
const state = responsiveFn({
  lang: 'zh-cn',
  message: zhCN
}); // 响应式的对象状态,这样当使用use方法改变语言设置时，页面会更新

export default {
  message() {
    return state.message;
  },
  lang() {
    return state.lang;
  },
  use(lang, message) {
    state.lang = lang;
    state.message = message;
  },
  create(componentName) {
    return {
      t(key) {
        var _state$message$compon, _state$message;
        let obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const string = ((_state$message$compon = state.message[componentName]) === null || _state$message$compon === void 0 ? void 0 : _state$message$compon[key]) || ((_state$message = state.message) === null || _state$message === void 0 ? void 0 : _state$message.common[key]) || '';
        // 例如：共{total}条 替换成
        return string.replace(/\{(.+?)\}/g, (_, param) => {
          return obj[param];
        });
      }
    };
  }
};